// extracted by mini-css-extract-plugin
export default {"page-container":"footer_page-container__h+k5G","content-wrap":"footer_content-wrap__DFTXD","footer":"footer_footer__ID6Ci"};